import { render } from "./WishlistTrigger.vue?vue&type=template&id=6ece64ad"
import script from "./WishlistTrigger.vue?vue&type=script&lang=js"
export * from "./WishlistTrigger.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__